import React, {useState} from "react";
import "./Picture.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const Picture = ({solved, relaySolved, pictureConnected, overWriteFunction, index}) => {
    const mainDiv = (
        <>

        </>
    );

    return (
        <RiddleCard title={"Picture"} allSolved={solved} mainInfo={mainDiv} connected={pictureConnected} overwriteString={overWriteFunction} index={index}></RiddleCard>
    )
}

export default Picture;